import { useEffect, useRef } from "react";

import { AutoScrollOutlined } from "@aircall/icons";
import { Box, Button, Tooltip } from "@aircall/tractor";
import { useTranslation } from "react-i18next";

import { useAutoScrollState } from "@/hooks/useAutoScrollState/useAutoScrollState";
import { useCall } from "@/hooks/useCall/useCall";
import { useTrack } from "@/hooks/useTrack/useTrack";

export function FloatingButton() {
  const { track } = useTrack();
  const { t } = useTranslation();
  const { activate, autoScrollEnabled } = useAutoScrollState();

  const hasScrolled = useRef(false);

  const { call } = useCall();

  const handleOnClick = () => {
    track("transcript_autoscroll_resumed", {
      call_id: call?.id,
      call_uuid: call?.uuid,
    });
    activate();
  };

  useEffect(() => {
    // Dirty patch to avoid rendering the button for the first time, although the auto scroll is disabled.
    if (autoScrollEnabled) {
      hasScrolled.current = true;
    }
  }, [autoScrollEnabled]);

  if (autoScrollEnabled || !hasScrolled.current) {
    return null;
  }

  return (
    <Tooltip title={t("resume_autoscroll")} side="top" align="end">
      <Box
        data-test="go-to-top-button"
        position="absolute"
        right="24px"
        zIndex="1"
      >
        <Button variant="secondary" onClick={handleOnClick}>
          <AutoScrollOutlined />
        </Button>
      </Box>
    </Tooltip>
  );
}
